<template>
  <div class="wrap" style="margin:0;">
    <div class="top">
      <div class="tit">{{ title }}</div>
      <div class="closebtn" @click="backTo">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </div>
    </div>
    <iframe v-if="url" id=“frame” :src="url" style="width: 100%;height:100%;border: 0;margin:0;padding: 0;"></iframe>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      url: '',
      title: '',
    };
  },
  methods: {
    backTo() {
      this.$router.back()
    },
  },
  mounted() {
    const { url, title } = this.$route.query
    this.url = url
    this.title = title
    console.log(url)
  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .top {
    height: 42px;
    line-height: 40px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    background-color: #F8F8F8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    box-sizing: border-box;

    .closebtn {
      cursor: pointer;
      width: 42px;
      text-align: center;
    }
  }
}
</style>
